import AOS from '../../../../../../node_modules/aos/dist/aos.js';

class Tabs {
  #activeTab = null;
  #tabElement = null;
  #tabDesktopForm = null;
  #tabMobileForm = null;
  #tabElements = null;
  #tabSelected = null;
  #tabsState = [];

  constructor(tabElement, defaultTab = 'default') {
    this.#tabElement = tabElement;
    this.#tabDesktopForm = this.#tabElement.querySelector('[data-tabs-desktop-form]');
    this.#tabElements = this.#tabElement.querySelectorAll('[data-tab]');
    this.#tabMobileForm = this.#tabElement.querySelector('[data-tabs-form]');
    this.#tabSelected = this.#tabElement.querySelector('[data-tab-selected]');
    this.#activeTab = this.#tabElements[0].dataset?.tab || defaultTab;
    this.init();
  }

  init() {
    for(const tabs of this.#tabElements) {
      this.#tabsState.push(
          {
            tabName: tabs.dataset.tab,
            selected: null,
          }
      );
    }
    this.#tabElements.forEach((tab) => {
      tab.classList.add('visually-hidden');
    });

    this.#tabElement.querySelector(`[data-tab="${this.#activeTab}"]`).classList.remove('visually-hidden');

    this.#tabDesktopForm.addEventListener('change', (e) => {
      e.preventDefault();
      const name = this.#tabDesktopForm.querySelector(`label[for="${e.target.id}"]`).textContent;
      this.changeTab(e.target.value, name);
    });

    this.#tabMobileForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const value = this.#tabMobileForm.querySelector('input:checked').value;
      const name = this.#tabMobileForm.querySelector('input:checked + label').textContent;
      this.changeTab(value, name);
    });

    setTimeout(() => {
      const value = this.#tabDesktopForm.querySelector('input:checked').value;
      const name = this.#tabDesktopForm.querySelector('input:checked + label').textContent;
      this.changeTab(value, name);
    }, 100);
  }

  changeTab = (value, name) => {
    const previousTab = this.#tabElement.querySelector(`[data-tab="${this.#activeTab}"]`);
    const newTab = this.#tabElement.querySelector(`[data-tab="${value}"]`);
    const newTabFirstItem = newTab.querySelector('[data-list-item]');
    const previousSelectedItem = previousTab.querySelector('.is-active');

    previousTab.classList.add('visually-hidden');

    newTab.classList.remove('visually-hidden');

    // if (newTab.offsetTop <= window.innerHeight) {
    //   scrollTo(0, newTab.offsetTop + (window.innerHeight / 2) + 100);
    // } else {
    //   scrollTo(0, newTab.offsetTop - (window.innerHeight / 2));
    // }

    AOS.refresh();

    this.#activeTab = value;

    this.#tabSelected.textContent = name;

    this.#tabDesktopForm.querySelector(`input[value="${value}"]`).checked = true;
    this.#tabMobileForm.querySelector(`input[value="${value}"]`).checked = true;

    // Фиксируем в объекте наш прошлый выбор
    this.#tabsState.filter((tab) => {
      if (tab.tabName === previousTab.dataset.tab) {
        tab.selected = previousSelectedItem;
        tab.itemText = previousSelectedItem.textContent;
      }
    }
    );

    // При выборе новой вкладки, включаем класс is-active у нужного item-list, а также отображаем нужный content-block
    this.#tabsState.filter((tab) => {
      if (tab.tabName === newTab.dataset.tab) {
        if (tab.selected === null) {
          newTabFirstItem.classList.add('is-active');
          newTab.querySelector(`[data-content-block="${newTabFirstItem.dataset.target}"]`).style.display = 'block';
        } else {
          tab.selected.classList.add('is-active');
          newTab.querySelector(`[data-content-block="${tab.selected.dataset.target}"]`).style.display = 'block';
        }
      }
    }
    );
  };

}

const initTabs = () => {
  const tabs = document.querySelectorAll('[data-tabs]');
  if (tabs.length) {
    tabs.forEach((tab) => {
      const tabElement = new Tabs(tab);
    });
  }
};

export { initTabs };
